<template>
  <div id="AddSchoolContact" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回高中職窗口列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>地區:<br>
                <select v-model="inputData.cid" @change="updateCityAndSchool">
                  <option selected="selected" value="">請選擇地區</option>
                  <option v-for="school in localInputData3" :key="`${school.cid}_${school.schoolID}`" :value="school.cid">
                    {{ school.city }}
                  </option>
                </select>
              </div>
            </td>
            <td style="min-width: 3em">
              <div>
                <span class="red_star">＊</span>學校名稱:<br>
                <select v-model="inputData.schoolID" @change="updateSchool">
                  <option selected="selected" value="">請選擇學校名稱</option>
                  <option
                    v-for="school in localInputData2"
                    :key="school.schoolID"
                    :value="school.schoolID"
                  >
                    {{ school.schoolName }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <div>
                <span class="red_star">＊</span>單位:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.unitName"

                  placeholder="請輸入單位名稱"
                />
              </div>
            </td>
            <td>
              <div>
                <span class="red_star">＊</span>姓名:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.contactName"

                  placeholder="請輸入姓名"
                />
              </div>
            </td>
            <td>
              <div>
                <span class="red_star">＊</span>職稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.jobTitle"

                  placeholder="請輸入職稱"
                />
              </div>
            </td>
            <td>
              <div>
                <span class="red_star">＊</span>電話/手機電話:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.cellPhone"
                  pattern="/^\d{10}$/"
                 onKeyPress="if(this.value.length==10) return false;"

                  placeholder="請輸入電話/手機電話"
                />
              </div>
            </td>
            <td>
              <div>
                <span class="red_star">＊</span>EMail:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.EMail"

                  placeholder="請輸入EMail"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddSchoolContact()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
//import Vue from 'vue';
import * as tools from "../tool";

export default {
  name: "AddSchoolContact",

  data() {
    return {
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      localInputData2: [], // 使用組件內部的 data 來保存 inputData2 的副本
      orglocalInputData2:[],
      localInputData3: null,
      originalLocalInputData2: [],
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        city:null,
        cid:'',
        schoolName: null,
        schoolID:'',
      },
      currentPage: 1,
      cid: "",
      pageSize: 10,

    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    updateCityAndSchool() {

  // 在這裡獲取選中的City
  const selectedSchool = this.orglocalInputData2.find(school => school.cid === this.inputData.cid);

  // 更新inputData.city
  if (selectedSchool) {
    this.inputData.city = selectedSchool.city;



    // 觸發更新學校名稱的下拉選單
    this.updateSchool2();
  }
},
  updateSchool2() {
  // 在這裡獲取選中的學校對象
  const selectedSchools = this.orglocalInputData2.filter(school => school.cid === this.inputData.cid);


  this.localInputData2 = [...selectedSchools];

  this.inputData.schoolID = ''; // 清空已選擇的學校名稱
},

    updateSchool() {
      // 在這裡獲取選中的學校對象
      const selectedSchool = this.localInputData2.find(school => school.schoolID === this.inputData.schoolID);

      // 更新inputData.schoolName
      if (selectedSchool) {
        this.inputData.schoolName = selectedSchool.schoolName;
      }
    },


    checkInput() {
      this.inputFlag = false;
      if (tools.empty(this.inputData.cid)) {
        alert("請選擇地區");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.inputData.schoolID)) {
        alert("請輸入學校名稱");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.inputData.unitName)) {
        alert("請輸入單位名稱");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.inputData.contactName)) {
        alert("請輸入姓名");
        this.inputFlag = true;
        return;
      }

      if (tools.empty(this.inputData.jobTitle)) {
        alert("請輸入職稱");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.inputData.cellPhone)) {
        alert("請輸入電話/手機電話");
        this.inputData.cellPhone="";
        this.inputFlag = true;
        return;
      }


    },
    AddSchoolContact() {
      this.checkInput();
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/AddSchoolContact/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加高中職窗口成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加高中職窗口失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    getAllSchoolCity() {
  let vm = this;
  this.$http
    .get("./WebApi/HighSchoolEnrolling/GetAllSchoolCity/")
    .then((response) => {
      if (!tools.isNull(response)) {
        vm.orglocalInputData2 = response.data;
        vm.localInputData2 =vm.orglocalInputData2;

        // 使用Set物件來儲存不重複的CID和City組合
        const uniqueCombinations = new Set();

        // 過濾掉重複的CID和City，並存放到localInputData2中
        vm.localInputData3 = vm.localInputData2.filter((item) => {
          const combination = `${item.cid}_${item.city.trim()}`;
          if (!uniqueCombinations.has(combination)) {
            uniqueCombinations.add(combination);
            return true;
          }
          return false;
        });



      }
    })
    .catch(function (error) {
      alert("網路連線失敗" + error);
    });
},

    close() {
      this.$emit("hideModal");
    },
  },
  mounted() {
    console.log("======created AddSchoolContactView =====");
    this.getAllSchoolCity();

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
